import { MultiSelect, MultiSelectChangeEvent } from "primereact/multiselect";
import { useCallback, useMemo } from "react";
import { ColumnFilterElementTemplateOptions } from "primereact/column";
import { useTranslation } from "react-i18next";

export const EvidenceFilter = (options: ColumnFilterElementTemplateOptions) => {
    const { t } = useTranslation("locale");

    const evidenceFilterOptions = useMemo(
        () => [
            {
                value: t("defectsTable.provided"),
                label: t("defectsTable.provided")
            },
            {
                value: t("defectsTable.notProvided"),
                label: t("defectsTable.notProvided")
            }
        ],
        []
    );

    const onChange = useCallback(
        (event: MultiSelectChangeEvent) =>
            options.filterApplyCallback(event.value),
        [options]
    );

    return (
        <MultiSelect
            data-cy="evidence-filter-input"
            value={options.value}
            options={evidenceFilterOptions}
            onChange={onChange}
            placeholder={t("defectsTable.showAll")}
            className="p-column-filter"
            showClear
        />
    );
};
